import { FC } from 'react';

import { Dialog, DialogContent, Drawer, DrawerContent } from '../../ui';
import { useViewportStore } from '../viewport';
import { useModalSystem } from './model';
import { IModalSystem } from './types';

const ModalSystemItem: FC<IModalSystem> = ({
  id,
  component,
  disableOutsideClick = false,
}) => {
  const isMobile = useViewportStore((state) => state.isMobile);

  const closeModal = useModalSystem((state) => state.closeModal);

  const closeModalHandler = (open: boolean) => {
    if (!open) closeModal(id);
  };

  const Component = component;
  if (isMobile)
    return (
      <Drawer
        dismissible={!disableOutsideClick}
        open
        onOpenChange={closeModalHandler}
      >
        <DrawerContent
          closeButton={null}
          overlayClassName="backdrop-blur-[20px] bg-modal"
          className="!max-w-auto bottom-1 overflow-hidden rounded-none !bg-[transparent] px-1"
        >
          <Component />
        </DrawerContent>
      </Drawer>
    );
  return (
    <Dialog open onOpenChange={closeModalHandler}>
      <DialogContent
        disableOutsideClick={disableOutsideClick}
        closeButton={null}
        overlayClassName="backdrop-blur-[20px] bg-modal"
        className="!max-w-auto block w-max overflow-hidden rounded-none border-none !bg-[transparent] !p-0 shadow-none"
      >
        <Component />
      </DialogContent>
    </Dialog>
  );
};

export const ModalSystem: FC = () => {
  const modals = useModalSystem((state) => state.modals);

  return modals.map((modal) => <ModalSystemItem key={modal.id} {...modal} />);
};
